<div fxLayout="row">
  <div>
    <mat-icon class="success-icon-snackbar">check</mat-icon>
  </div>
  <div>
    <span>{{data.message}}</span>
  </div>
</div>
